var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25895 13.6129V9.26514H9.73718V13.6129C9.73718 14.0912 10.1285 14.4825 10.6067 14.4825H13.2154C13.6937 14.4825 14.085 14.0912 14.085 13.6129V7.52603H15.5632C15.9632 7.52603 16.1545 7.03038 15.8502 6.76951L8.58067 0.221737C8.25024 -0.0739125 7.7459 -0.0739125 7.41546 0.221737L0.145957 6.76951C-0.149693 7.03038 0.0329144 7.52603 0.432911 7.52603H1.91116V13.6129C1.91116 14.0912 2.30246 14.4825 2.78072 14.4825H5.38939C5.86765 14.4825 6.25895 14.0912 6.25895 13.6129Z",
    fill: "#006AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.0d5d295fa44b1406478e3c6002409fa5.svg";
export { ForwardRef as ReactComponent };